import { useQuery, useMutation } from '@apollo/client';
import { toast } from 'react-hot-toast';
import { UPDATE_PAYMENT_REMINDER } from 'graphql/mutation/commande/updatePaymentReminder';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { GraphQLError } from 'graphql';
import React from 'react';
import CommandeSingle from './CommandeSingle';
import { getCommandeDefFromQuery } from 'helpers/transformApiResponse/commande';
import QUERY_COMMANDE_DETAILS from '../../graphql/query/commande/commandeDetails';
import { CommandeDetailsQuery } from '../../graphql/generated/graphql';

const CommandeSinglePage = ({ match }) => {
  const { data, error, loading } = useQuery<CommandeDetailsQuery>(
    QUERY_COMMANDE_DETAILS,
    {
      variables: { id: match && match.params.id }
    }
  );

  const [updateToPaymentReminder] = useMutation(UPDATE_PAYMENT_REMINDER, {
    onCompleted: () => {
      toast.success('Commande relancé', {
        icon: '🎉'
      });
    },
    onError: () => {
      toast.error('Erreur dans la mise à jour de la commande', {
        icon: '😕'
      });
    },
    refetchQueries: [{ query: QUERY_COMMANDE_DETAILS }, 'getSingleCommande']
  });

  const onUpdatePayment = async () => {
    await updateToPaymentReminder({
      variables: {
        id: parseInt(data.commande.data.id),
        paymentreminder: true
      }
    });
  };

  if (loading) return <LoadingLayout />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new GraphQLError('Erreur dans la récupération de la commande')
        }
      />
    );
  return (
    <CommandeSingle
      commande={getCommandeDefFromQuery(data.commande.data)}
      onUpdatePayment={onUpdatePayment}
    />
  );
};

export default CommandeSinglePage;
